package org.zest.insan_360_website.pages

import org.zest.insan_360_website.data.localized

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.invoke
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.icons.fa.FaAsterisk
import com.varabyte.kobweb.silk.components.icons.fa.FaEye
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.common.PlaceholderColor
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.Text
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.DotLoading
import org.zest.insan_360_website.components.widgets.LocalToast
import org.zest.insan_360_website.components.widgets.ToastType
import org.zest.insan_360_website.data.page_states.AuthState.requestSignup
import org.zest.insan_360_website.data.page_states.SignUpPageState.currentRegState
import org.zest.insan_360_website.data.page_states.SignUpPageState.isLoading
import org.zest.insan_360_website.data.page_states.SignUpPageState.isRevealed
import org.zest.insan_360_website.data.page_states.SignUpPageState.isRevealedConfirm
import org.zest.insan_360_website.data.page_states.SignUpPageState.signUpState
import org.zest.insan_360_website.data.page_states.UserPreferences

enum class RegisterState { Default, Organization, Confirmation }

data class SignUpState(
    val organization: String = "",
    val name: String = "",
    val email: String = "",
    val password: String = "",
    val confirmationPass: String = "",
    val nationalId: String = "",
    val addressLine1: String = "",
    val addressLine2: String = "",
    val city: String = "",
    val state: String = "",
    val postalCode: String = "",
    val country: String = "Malaysia",
    val phone: String = "",
    val workType: String = "",
    val position: String = "",
    val isLoading: Boolean = false,
) {
    companion object {
        val NAME_REGEX = Regex("^[a-zA-Z\\s\\-']{3,250}$")
        val EMAIL_REGEX = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[a-zA-Z]+$")
        val NRIC_REGEX = Regex("^\\d{12}$")
        val PHONE_REGEX = Regex("^\\+?[0-9]{10,15}$")
        val PASSWORD_REGEX = Regex("^(?=.*[A-Z])(?=.*\\d).{8,}$")
        val ORG_REGEX = Regex("^[a-zA-Z0-9\\s\\-',.&]{2,250}$")
        val POSITION_REGEX = Regex("^[a-zA-Z0-9\\s\\-'&/]{2,100}$")
        val POSTAL_REGEX = Regex("^\\d{4,10}$")
    }

    fun validate(currentRegState: RegisterState): String? {

        val cleanName = name.trim()
        val cleanEmail = email.trim()
        val cleanNationalId = nationalId.trim()
        val cleanPhone = phone.trim()
        val cleanOrg = organization.trim()
        val cleanPosition = position.trim()
        val cleanCity = city.trim()
        val cleanState = state.trim()
        val cleanPostal = postalCode.trim()
        val cleanCountry = country.trim()

        if (currentRegState != RegisterState.Confirmation) {
            val hasBaseFields = cleanName.isNotBlank() && cleanEmail.isNotBlank() &&
                    cleanNationalId.isNotBlank() && addressLine1.isNotBlank() &&
                    cleanCity.isNotBlank() && cleanState.isNotBlank() && cleanPostal.isNotBlank() && cleanCountry.isNotBlank() &&
                    cleanPhone.isNotBlank() && workType.isNotBlank()

            if (!hasBaseFields) return authWordLibrary.fillAllRequiredFields.localized // Language set all regex error
            if (currentRegState == RegisterState.Organization) {
                if (cleanOrg.isBlank() || cleanPosition.isBlank()) {
                    return authWordLibrary.fillOrgAndPosition.localized
                }
            }
            if (!cleanName.matches(NAME_REGEX)) return authWordLibrary.nameFormatError.localized
            if (!cleanEmail.matches(EMAIL_REGEX)) return authWordLibrary.emailFormatError.localized
            if (!cleanNationalId.matches(NRIC_REGEX)) return authWordLibrary.nricFormatError.localized
            if (!cleanPhone.matches(PHONE_REGEX)) return authWordLibrary.phoneFormatError.localized
            if (!cleanPostal.matches(POSTAL_REGEX)) return authWordLibrary.postalCodeError.localized
            if (currentRegState == RegisterState.Organization) {
                if (!cleanOrg.matches(ORG_REGEX)) return authWordLibrary.orgNameError.localized
                if (!cleanPosition.matches(POSITION_REGEX)) return authWordLibrary.positionError.localized
            }
            return null
        }
        val isSimilar = password == confirmationPass
        if (password.isBlank() || confirmationPass.isBlank()) return authWordLibrary.enterPasswordAndConfirmation.localized
        if (!password.matches(PASSWORD_REGEX) || !confirmationPass.matches(PASSWORD_REGEX)) return authWordLibrary.passwordComplexError.localized
        if (!isSimilar) return authWordLibrary.passwordsDoNotMatch.localized
        return null
    }
}

@Page
@Layout(".components.layouts.MainPageLayout")
@Composable
fun RegisterPage() {
    val scope = rememberCoroutineScope()
    val toast = LocalToast.current

    SignupPageContentContainer {
        H2(
            Modifier
                .textAlign(TextAlign.Center)
                .padding(topBottom = 0.25.cssRem)
                .margin(0.px)
                .toAttrs()
        )
        { Text(authWordLibrary.beginJourney.localized) }
        RegisterStateToggle()
        SignUpInputLayout(
            state = signUpState,
            onStateChange = { mutator -> signUpState = mutator(signUpState) },
            onBack = { currentRegState = RegisterState.Default },
        ) {
            val errorMessage = signUpState.validate(currentRegState)
            if (errorMessage != null) {
                toast.show(errorMessage, ToastType.ERROR)
            } else {
                when (currentRegState) {
                    RegisterState.Confirmation -> {
                        isLoading = true
                        requestSignup(scope, toast) { isLoading = false }
                    }

                    else -> {
                        currentRegState = RegisterState.Confirmation
                    }
                }
            }
        }
    }
}

@Composable
fun SignupPageContentContainer(content: @Composable () -> Unit) {
    Box(
        Modifier.fillMaxSize().then(fontSizeBreakpoints.toModifier()),
        contentAlignment = Alignment.Center
    ) {
        Column(
            Modifier
                .width(20.cssRem)
                .borderRadius(0.5.cssRem)
                .backgroundColor(Colors.White)
                .padding(1.cssRem)
                .gap(0.5.cssRem)
                .position(Position.Relative)
                .overflow(Overflow.Hidden),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            content()
        }
    }
}

@Composable
fun SignUpInputLayout(
    state: SignUpState,
    onStateChange: ((SignUpState) -> SignUpState) -> Unit,
    onBack: () -> Unit,
    onSubmitAction: () -> Unit
) {
    Form(
        attrs = Modifier.fillMaxWidth().toAttrs {
            onSubmit {
                it.preventDefault()
                onSubmitAction()
            }
        }
    ) {
        Column(
            Modifier
                .fillMaxSize()
                .zIndex(1)
                .gap(0.5.cssRem),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            if (currentRegState != RegisterState.Confirmation) {
                if (currentRegState == RegisterState.Organization) {
                    CustomInput(
                        inputType = InputType.Text,
                        value = state.organization,
                        onValueChange = { newValue -> onStateChange { it.copy(organization = newValue) } },
                        placeholder = authWordLibrary.organization.localized,
                        required = true
                    )
                }
                CustomInput(
                    inputType = InputType.Text,
                    value = state.name,
                    onValueChange = { newValue -> onStateChange { it.copy(name = newValue) } },
                    placeholder = authWordLibrary.fullName.localized,
                    required = true,
                    autoComplete = "name"
                )
                CustomInput(
                    inputType = InputType.Email,
                    value = state.email,
                    onValueChange = { newValue -> onStateChange { it.copy(email = newValue) } },
                    placeholder = authWordLibrary.email.localized,
                    required = true,
                    autoComplete = "email"
                )
                CustomInput(
                    inputType = InputType.Text,
                    value = state.nationalId,
                    onValueChange = { newValue -> onStateChange { it.copy(nationalId = newValue) } },
                    placeholder = authWordLibrary.ic.localized,
                    required = true
                )
                CustomInput(
                    inputType = InputType.Text,
                    value = state.addressLine1,
                    onValueChange = { newValue -> onStateChange { it.copy(addressLine1 = newValue) } },
                    placeholder = "${authWordLibrary.addressLine.localized} 1",
                    required = true,
                    autoComplete = "address-line1"
                )
                CustomInput(
                    inputType = InputType.Text,
                    value = state.addressLine2,
                    onValueChange = { newValue -> onStateChange { it.copy(addressLine2 = newValue) } },
                    placeholder = "${authWordLibrary.addressLine.localized} 2",
                    autoComplete = "address-line2"
                )
                Row(Modifier.fillMaxWidth().gap(0.5.cssRem)) {
                    Box(Modifier.weight(1f)) {
                        CustomInput(
                            inputType = InputType.Text,
                            value = state.city,
                            onValueChange = { newValue -> onStateChange { it.copy(city = newValue) } },
                            placeholder = authWordLibrary.city.localized,
                            required = true,
                            autoComplete = "address-level2"
                        )
                    }
                    Box(Modifier.weight(1f)) {
                        CustomInput(
                            inputType = InputType.Text,
                            value = state.state,
                            onValueChange = { newValue -> onStateChange { it.copy(state = newValue) } },
                            placeholder = authWordLibrary.state.localized,
                            required = true,
                            autoComplete = "address-level1"
                        )
                    }
                }
                Row(Modifier.fillMaxWidth().gap(0.5.cssRem)) {
                    Box(Modifier.weight(1f)) {
                        CustomInput(
                            inputType = InputType.Text,
                            value = state.postalCode,
                            onValueChange = { newValue -> onStateChange { it.copy(postalCode = newValue) } },
                            placeholder = authWordLibrary.postalCode.localized,
                            required = true,
                            autoComplete = "postal-code"
                        )
                    }
                    Box(Modifier.weight(1f)) {
                        CustomInput(
                            inputType = InputType.Text,
                            value = state.country,
                            onValueChange = { newValue -> onStateChange { it.copy(country = newValue) } },
                            placeholder = authWordLibrary.country.localized,
                            required = true,
                            autoComplete = "country-name"
                        )
                    }
                }
                CustomInput(
                    inputType = InputType.Tel,
                    value = state.phone,
                    onValueChange = { newValue -> onStateChange { it.copy(phone = newValue) } },
                    placeholder = authWordLibrary.phone.localized,
                    required = true,
                    autoComplete = "tel"
                )
                CustomInput(
                    inputType = InputType.Text,
                    value = state.workType,
                    onValueChange = { newValue -> onStateChange { it.copy(workType = newValue) } },
                    placeholder = authWordLibrary.work.localized,
                    required = true
                )
                if (currentRegState == RegisterState.Organization) {
                    CustomInput(
                        inputType = InputType.Text,
                        value = state.position,
                        onValueChange = { newValue -> onStateChange { it.copy(position = newValue) } },
                        placeholder = authWordLibrary.position.localized,
                        required = true
                    )
                }
            } else {
                CustomInput(
                    inputType = InputType.Password,
                    value = state.password,
                    onValueChange = { newValue -> onStateChange { it.copy(password = newValue) } },
                    placeholder = authWordLibrary.password.localized,
                    required = true,
                    isRevealed = isRevealed,
                    autoComplete = "new-password"
                ) { revealState -> isRevealed = !revealState }
                CustomInput(
                    inputType = InputType.Password,
                    value = state.confirmationPass,
                    onValueChange = { newValue -> onStateChange { it.copy(confirmationPass = newValue) } },
                    placeholder = authWordLibrary.confirmPassword.localized,
                    required = true,
                    isRevealed = isRevealedConfirm,
                    autoComplete = "new-password"
                ) { revealState -> isRevealedConfirm = !revealState }
            }
            if (currentRegState != RegisterState.Confirmation) {
                Button(
                    onClick = { onSubmitAction() },
                    modifier = buttonColorStyle.toModifier()
                        .fillMaxWidth()
                ) {
                    SpanText(
                        authWordLibrary.proceed.localized,
                        contentButtonTextStyle.toModifier().fontSize(1.cssRem)
                    )
                }
                A(
                    href = "/", attrs = Modifier
                        .textAlign(TextAlign.Center)
                        .fontSize(0.75.cssRem)
                        .color(darkGreenColor)
                        .toAttrs()
                ) {
                    Text(
                        authWordLibrary.haveAccount.localized
                    )
                }
            } else {
                Row(Modifier.fillMaxWidth().gap(0.25.cssRem)) {
                    Button(
                        onClick = { onBack() },
                        modifier = buttonColorStyle.toModifier()
                            .fillMaxWidth()
                    ) {
                        SpanText(
                            authWordLibrary.back.localized,
                            contentButtonTextStyle.toModifier().fontSize(1.cssRem)
                        )
                    }
                    Button(
                        onClick = { onSubmitAction() },
                        modifier = buttonColorStyle.toModifier()
                            .fillMaxWidth()
                    ) {
                        if (isLoading) DotLoading()
                        else SpanText(
                            authWordLibrary.signup.localized,
                            contentButtonTextStyle.toModifier().fontSize(1.cssRem)
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun CustomInput(
    inputType: InputType<String>,
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String,
    required: Boolean = false,
    isRevealed: Boolean = false,
    autoComplete: String? = null,
    onRevealChange: (Boolean) -> Unit = {}
) {
    val inputModifier = baseInputStyle.toModifier().let { base ->
        if (autoComplete != null) {
            base.attrsModifier {
                attr("autocomplete", autoComplete)
                attr("name", autoComplete)
                attr("id", autoComplete)
            }
        } else {
            base.attrsModifier {
                attr("name", placeholder.replace(" ", "_").lowercase())
            }
        }
    }

    Box(
        Modifier
            .fillMaxWidth()
            .position(Position.Relative)
    ) {
        if (inputType != InputType.Password) {
            Input(
                modifier = inputModifier,
                focusBorderColor = lightGreenColor,
                placeholderColor = PlaceholderColor(lightGreenColor),
                type = inputType,
                value = value,
                onValueChange = { onValueChange(it) },
                placeholder = placeholder
            )
        } else {
            Input(
                modifier = inputModifier,
                focusBorderColor = lightGreenColor,
                placeholderColor = PlaceholderColor(lightGreenColor),
                type = if (isRevealed) InputType.Text else InputType.Password,
                value = value,
                onValueChange = { onValueChange(it) },
                placeholder = placeholder
            )
        }
        if (required && inputType != InputType.Password) {
            val hasText = value.isNotEmpty()
            FaAsterisk(
                Modifier
                    .position(Position.Absolute)
                    .opacity(if (hasText) 0.25 else 1.0)
                    .top(50.percent)
                    .right(0.px)
                    .translate(tx = (-0.5).cssRem, ty = (-50).percent)
            )
        }
        if (inputType == InputType.Password) {
            FaEye(
                Modifier
                    .position(Position.Absolute)
                    .top(50.percent)
                    .opacity(if (isRevealed) 0.25 else 1.0)
                    .right(0.px)
                    .translate(tx = (-0.5).cssRem, ty = (-50).percent)
                    .onTouchStart { onRevealChange(isRevealed) }
                    .onTouchEnd { onRevealChange(isRevealed) }
                    .onClick { onRevealChange(isRevealed) }
                    .cursor(Cursor.Pointer)
            )
        }
    }
}

val RegisterTabTextStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .fontWeight(FontWeight.SemiBold)
            .fontSize(0.8.cssRem)
            .color(Colors.White)
            .textAlign(TextAlign.Center)
            .cursor(Cursor.Pointer)
            .padding(topBottom = 0.75.cssRem)
            .transition {
                "color" { duration(0.2.s) }
            }
    }
    hover {
        Modifier.color(authPageColor.darkened(0.75f))
    }
}

@Composable
fun RegisterStateToggle() {
    Box(
        Modifier
            .fillMaxWidth()
            .backgroundColor(authPageColor)
            .borderRadius(1.cssRem)
            .padding(0.125.cssRem)
    ) {
        Row(Modifier.fillMaxSize()) {
            if (currentRegState != RegisterState.Confirmation) {
                SpanText(
                    authWordLibrary.individual.localized,
                    RegisterTabTextStyle.toModifier().then(Modifier.onClick {
                        currentRegState = RegisterState.Default
                    })
                )
                SpanText(
                    authWordLibrary.organization.localized,
                    RegisterTabTextStyle.toModifier().then(Modifier.onClick {
                        currentRegState = RegisterState.Organization
                    })
                )
            } else {
                SpanText(
                    authWordLibrary.passwordConfirmation.localized,
                    RegisterTabTextStyle.toModifier()
                )
            }
        }
        Box(
            Modifier
                .fillMaxHeight()
                .fillMaxWidth(if (currentRegState != RegisterState.Confirmation) 50.percent else 100.percent)
                .backgroundColor(Colors.White)
                .borderRadius(0.875.cssRem)
                .translate(tx = if (currentRegState != RegisterState.Organization) 0.px else 100.percent)
                .transition {
                    "transform" { duration(0.35.s) }
                }
        ) {
            SpanText(
                when (currentRegState) {
                    RegisterState.Default -> authWordLibrary.individual.localized
                    RegisterState.Organization -> authWordLibrary.organization.localized

                    RegisterState.Confirmation -> authWordLibrary.passwordConfirmation.localized
                },
                RegisterTabTextStyle.toModifier().then(Modifier.color(authPageColor.darkened(0.75f)))
            )
        }
    }
}